import Alert from "@mui/material/Alert";
import BasicModal from "@/components/basic-modal";

const CloseConfirmationModal = ({
  open,
  onClose,
  onConfirmCancel,
  loading,
}) => {
  const onConfirm = () => {
    onConfirmCancel();
    // handleClose();
  };

  const handleClose = () => {
    onClose();
  };

  const modalInfo = dataSet.confirmCancelModal;

  return (
    <BasicModal
      open={open}
      title={modalInfo.title}
      handleClose={handleClose}
      saveButtonTitle={modalInfo.btnText}
      saveCallback={onConfirm}
      size={"sm"}
      saveBtnLoading={loading}
      saveBtnDisabled={loading}
      modalBodySx={{ padding: "1rem" }}
    >
      <Alert severity={"warning"}>{modalInfo?.text}</Alert>
    </BasicModal>
  );
};

export default CloseConfirmationModal;

const dataSet = {
  confirmCancelModal: {
    title: "Closing Without Save",
    text: "If you close it, changes will not be saved. Are you sure do want to close?",
    btnText: "Close",
  },
};
